// extracted by mini-css-extract-plugin
export default {"gate":"gate---pR32P","actions":"actions---dXUbR"};